export const LAWN_SPACE_BEST_SCORE_KEY = 'wgis:lawn-space-shooter:best-score'

type ScoreStorage = Pick<Storage, 'getItem' | 'setItem'>

export function readLawnSpaceBestScore(
  storage?: ScoreStorage | null,
  key: string = LAWN_SPACE_BEST_SCORE_KEY,
): number {
  if (!storage) return 0

  try {
    const value = storage.getItem(key)
    if (!value) return 0
    const parsed = Number.parseInt(value, 10)
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0
  } catch {
    return 0
  }
}

export function writeLawnSpaceBestScore(
  score: number,
  storage?: ScoreStorage | null,
  key: string = LAWN_SPACE_BEST_SCORE_KEY,
): number {
  if (!storage) return Math.max(0, Math.round(score))

  const nextScore = Math.max(0, Math.round(score))
  const currentScore = readLawnSpaceBestScore(storage, key)
  const bestScore = Math.max(currentScore, nextScore)

  try {
    storage.setItem(key, String(bestScore))
  } catch {
    return currentScore
  }

  return bestScore
}

